const normalizePrefix = (prefix) => prefix?.replace('+', '') || '';

export function getCountryIsoCode(formData, countries) {
  const phonePrefixToIsoCode = (countries || []).reduce(
    (map, { phonePrefix, code }) => {
      if (phonePrefix && code) {
        map[normalizePrefix(phonePrefix)] = code;
      }
      return map;
    },
    {}
  );
  const isoCodes = new Set((countries || []).map(({ code }) => code));
  const countryCodeOrPhonePrefix = formData?.country_code;
  if (isoCodes.has(countryCodeOrPhonePrefix)) {
    return countryCodeOrPhonePrefix;
  }
  return (
    phonePrefixToIsoCode[normalizePrefix(countryCodeOrPhonePrefix)] || null
  );
}
